import { render } from "./MainVideo.vue?vue&type=template&id=26f27f20"
import script from "./MainVideo.vue?vue&type=script&lang=js"
export * from "./MainVideo.vue?vue&type=script&lang=js"

import "./MainVideo.vue?vue&type=style&index=0&id=26f27f20&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__